import React, { forwardRef } from "react";
import FabricImageEditor from "../../Editor/Fabric";

/**
 * ImageViewer — wraps FabricImageEditor.
 *
 * Props:
 *   src  : image data URL or remote URL (passed from MediaViewer)
 *   name : filename for reference
 *
 * Ref methods (passed through to FabricImageEditor):
 *   ref.current.getExportedDataUrl() — returns edited canvas as PNG data URL
 */

const ImageViewer = forwardRef(function ImageViewer({ src, name }, ref) {
  return <FabricImageEditor ref={ref} src={src} name={name} />;
});

export default ImageViewer;